define('modules/dashboardmenu/js/base.js',["app/module", "app/config", "app/user", "jquery", "app/util", "templates", "jquery.cookie", "bootstrap/popover"], function (module, config, user, $, util, templates) {
    return new module({
        name: 'dashboardmenu',
        selectors: '.mainMenuWrap',
        remoteData: [],

        config: {
            // TODO - Set up the proper or combined modal mode
            // TODO - Set up the data-attr apply config method
            mode: 'sidebaronly', // Two modes - full or sidebaronly
            pushPageContent: 'left', // Opening the menu pushes the page content to the left/right, defaults to left
            hoverMenuEnabled: false, // TODO - This is not implemented in any logic below
            formLocation: null,
            hideMenuOnForms: false,
            updateMenuText: true,
            delayOutTransition: false,
            openRoutes: ['register', 'login', 'forgot', 'reset'] // Default for forms
        },

        routes: [{
            route: '.*',
            fn: function (hash) {
                if (!this.getConfig().formLocation) {
                    this.updateToggleMenu(false);
                } else if (this.getConfig().openRoutes.indexOf(hash.split('/')[0]) == -1) {
                    if (this.appLoaded) {
                        this.updateToggleMenu(false);
                    } else {
                        this.appLoaded = true;
                    }
                }
            },
            extra: true,
            delay: 150
        }],

        initialize: function (data) {

            // Render the template
            $('.mainMenuWrap').append(templates.dashboardmenu());

            // Check initial config options
            if (this.getConfig().mode == 'sidebaronly') {
                $('.mainMenuWrap').find('#actionMenu, #centerMenuContent').hide(); // Initial state, we reset via CSS display inherit
            }
            if (this.getConfig().hideMenuOnForms) {
                $(this.getConfig().formLocation).hide();
            }

            var mainMenu = $('#mainMenu');

            // Only applies if the mainMenu is present
            if (mainMenu.length > 0) {

                // Detect and handle close button
                $('.dashboardToggle, #mainMenu .closeWrap').on('click', $.proxy(function (e) {
                    e.preventDefault();
                    this.updateToggleMenu(!$('#mainMenu').is(':visible'), false);
                    return false;
                }, this));

                $(document).on('click','body', function(e){
                    if (!$(e.target).closest("#sideMenu").length) {
                        if ($('#mainMenu').hasClass('open')) {
                            $('#mainMenu .closeWrap').trigger('click');
                        }
                    }
                });

                // Add body listener for menu status control
                $('body').on('updatedashboard', $.proxy(function (e, a, b, c) {
                    this.updateToggleMenu(a, b, c);
                }, this));

            }

            // Navbar flyout
            $('.partnerLink, .partnerFlyout .closeBtn').click(function (e) {
                e.preventDefault();
                $('.partnerFlyout').toggleClass('masked');
                setTimeout(function () {
                    $('.partnerFlyout').toggleClass('open');
                    $('.introPage').toggleClass('bumpLeft');
                }, 50);
            });

            $('.flyoutTrigger, .rightFlyout .closeBtn, .leftFlyout .closeBtn').click(function (e) {
                e.preventDefault();
                var flyoutEl = $(this).attr('data-flyout') || $(this).parents('.rightFlyout, .leftFlyout');
                $(flyoutEl).toggleClass('masked');
                setTimeout(function () {
                    $(flyoutEl).toggleClass('open');
                    $('.introPage').toggleClass('bumpRight');
                }, 50);
            });

            // Add tooltip dropdown support about button
            /*var popoverHtml = $('<ul class="aboutPopoverList"><li><a href="about.html">About</a></li><li><a href="#">About Two</a></li></ul>');
             $('.aboutHoverBtn').hover(function(){
             $(this).focus();
             }).popover({
             content: popoverHtml,
             html: true,
             placement: 'bottom',
             container: 'nav',
             trigger: 'focus',
             delay: {
             show: 0,
             hide: 250
             }
             });*/
        },

        methods: {

            updateToggleMenu: function (open, content, location) {

                // Check if we are just passing content, in which case do it silently
                if (typeof open == 'string' || typeof open == 'object') {
                    content = open;
                    open = null;
                }

                // Fire a global app event for open/close status
                if (open) {
                    $('body').trigger('mainnavopen');
                } else {
                    $('body').trigger('mainnavclose');
                }

                if ($('body').hasClass('delayOutTransition')) {
                    // handling for class if needed
                }
                else {
                    if (this.getConfig().hideMenuOnForms && this.getConfig().formLocation) {
                        $(this.getConfig().formLocation).hide();
                        $('#sideMenu').show();
                    }
                }


                if ($('#mainMenu').length > 0) {

                    // Reset visible elements
                    $('#mainMenu .actionContent').show(); //, #mainMenu .daysPromo').show();
                    $('#actionMenu').removeClass('hasMessage largeSuccess');

                    // Set the template content
                    if (content) {
                        var location = this.getConfig()['formLocation'];
                        if (location) {
                            $(location).html(content);
                            $(location).show();
                        } else {
                            $('#mainMenu .actionContent').html(content);
                        }
                    }

                    // Trigger the opening animation
                    if (open !== null) {
                        if (open == false) {

                            $('.navbarWrap').removeClass('move');
                            $('.navbar .navbar-header').removeClass('hideNav');
                            $('#mainMenu').addClass('closing');
                            $('#mainMenu').removeClass('open');
                            //$('.navbarWrap').addClass('slideUpOut');
                            $('.daysToRegister').removeClass('mobileNavVisible');
                            $('.hamburger-to-close').removeClass('changeclose');
                            $('.dashboardToggle').removeClass('open');
                            // $('.sidebar-item').removeClass('sidebar-item-selected');
                            $('.dashboard-footer-menu').fadeOut();
                            $('.singlePageWrap').removeClass('pushContentLeft pushContentRight');
                            $('#centerMenuContent').removeClass('sidebarPage');
                            // $('body').removeClass('locked');
                            if (this.getConfig().updateMenuText) {
                                $('.dashboard-menu-text').text('Menu');
                            }
                            if (!$('html').hasClass('touch')) {
                                util.lockScrolling(false, '#sideMenu .menuWrap');
                            }
                            setTimeout($.proxy(function () {
                                $('#mainMenu').hide();
                                $('#mainMenu').removeClass('closing');
                                if (this.getConfig().formLocation) {
                                    if (this.getConfig().openRoutes.indexOf(window.location.hash.substr(1).split('/')[0]) > -1) {
                                        window.location.hash = '';
                                    }
                                }
                                if (this.getConfig().mode == 'sidebaronly') {
                                    $('.mainMenuWrap').find('#actionMenu, #centerMenuContent').hide();
                                }
                            }, this), 1000);
                        }
                        else {

                            if ($('#mainMenu').hasClass('closing')) {
                                return;
                            }

                            $('#mainMenu').show();
                            $('.dashboard-footer-menu').fadeIn();
                            // $('body').addClass('locked');
                            $('.dashboardToggle').addClass('open');
                            $('.daysToRegister').addClass('mobileNavVisible');
                            $('.hamburger-to-close').addClass('changeclose');
                            $('.navbarWrap').addClass('move');
                            $('.navbar .navbar-header').addClass('hideNav');
                            if (this.getConfig().updateMenuText) {
                                $('.dashboard-menu-text').text('close');
                            }
                            if (!$('html').hasClass('touch')) {
                                util.lockScrolling(true, '#sideMenu .menuWrap');
                            }
                            setTimeout($.proxy(function () {
                                $('#mainMenu').addClass('open');
                                //$('.navbarWrap').addClass('slideDownIn');
                                if (this.getConfig().pushPageContent && this.getConfig().pushPageContent == 'left') {
                                    $('.singlePageWrap').addClass('pushContentLeft');
                                } else if (this.getConfig().pushPageContent && this.getConfig().pushContent == 'right') {
                                    $('.singlePageWrap').addClass('pushContentRight');
                                }
                            }, this), 30);
                        }
                    }

                } else {
                    // TODO - Refactor this into the modal methods
                    $('body').append($(templates.actionmodal({
                        content: content
                    })).modal());
                }

                // Pause any videos that are currently playing
                $('video').each(function (key, videoEl) {
                    $(videoEl).get(0).pause();
                });
            },

            initMenuHover: function (data) {
                // Add tooltip dropdown support to the menu
                var topMenuHtml = $('<ul></ul>');
                // Add the top title that opens the mainmenu
                topMenuHtml.append($('<h5>Menu Dashboard</h5>').click($.proxy(function (e) {
                    this.updateToggleMenu(true, false);
                }, this)));
                $.each(data, function (index, topLink) {
                    if (topLink.hovermenu) {
                        topMenuHtml.append($('<li><a href="' + topLink.link + '">' + topLink.text + '</a></li>'));
                    }
                });
                $('.dashboardToggle > a').hover(function () {
                    $(this).focus();
                    $(this).mouseleave(function (e) {
                        var target = e.toElement || e.relatedTarget;
                        if (!$(target).hasClass('popover') && $(target).parents('.popover').length == 0
                            && !$(target).hasClass('navbar')) {
                            $('#mainNavbar .popover').fadeOut();
                        }
                    });
                    $('#mainNavbar').find('.popover').mouseleave(function () {
                        $('#mainNavbar .popover').fadeOut();
                    });
                }).popover({
                    content: topMenuHtml[0],
                    html: true,
                    placement: 'bottom',
                    container: 'nav',
                    trigger: 'focus',
                    delay: {
                        show: 0,
                        hide: 500
                    }
                });

            },

            setFormComponent: function () {
                if (this.getConfig().hideMenuOnForms) {
                    $('#sideMenu').hide();
                    $('#centerMenuContent').css('width', 'auto').addClass('center-menu-open');
                }
            }
        }
    });
});
